import script from "./KrumosHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./KrumosHeader.vue?vue&type=script&setup=true&lang=ts"

import "./KrumosHeader.vue?vue&type=style&index=0&id=44342663&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44342663"]])

export default __exports__